<template>
    <transition name="slide-fade">
        <div class="modal" data-cy="modal_history_delivery_status" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full py-5">
                    <DeliveryDetail
                        :serialModel="serialModel"
                        @onCopy="onCopy()" />
                    <div class="px-6">
                        <DeliveryAddress :serialModel="serialModel" />
                    </div>
                    <!-- <DeliveryStatus :serialModel="serialModel" /> -->
                    <div class="m-auto w-11/12 pt-4">
                        <WhiteButton data-cy="btn_history_delivery_status_close" @click="clickOk()">
                            {{btnOk}}
                        </WhiteButton>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//component
import DeliveryDetail from "./component/DeliveryDetail.vue";
import DeliveryAddress from "./component/DeliveryAddress.vue";
// import DeliveryStatus from "./component/DeliveryStatus.vue";
import WhiteButton from '@/components/Button/WhiteButton.vue';

export default {
    name: "DeliveryStatusModal",
    mixins: [LocaleMixin],
    components: {
        DeliveryDetail,
        DeliveryAddress,
        // DeliveryStatus,
        WhiteButton,
    },
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            busModal: null,

            serialModel: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.serialModel = config.serialModel;
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.close;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        onCopy: function(){
            this.controller.copySuccessModal
                            .clearModal()
                            .setIsBottom(true)
                            .show();
        }
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;
        .modal-content{
            position: absolute;
            bottom: 0;
            width: 100%;
            max-width: 500px;

        }
    }
</style>
